import React, { KeyboardEvent, ReactNode } from 'react';

interface LoginLayoutProps {
    logo: ReactNode;
    meta?: ReactNode;
    title: ReactNode;
    subtitle?: ReactNode;
    beforeForm?: ReactNode;
    children: ReactNode;
    footer?: ReactNode;
    fullWidth?: boolean;
    onKeyDown?: (e: KeyboardEvent<HTMLElement>) => void;
}

/**
 * Login shell shared between admin and cabinet (keep copies in sync).
 * Auth fields stay app-specific; layout/centering must stay identical.
 */
const LoginLayout = ({
    logo,
    meta = null,
    title,
    subtitle = null,
    beforeForm = null,
    children,
    footer = null,
    fullWidth = false,
    onKeyDown,
}: LoginLayoutProps) => (
    <article className="login__wrapper">
        <header className="login__header">
            {logo}
            {meta}
        </header>
        <div className="login__content">
            <main
                className={`login${fullWidth ? ' login_full-width' : ''}`}
                onKeyDown={onKeyDown}
            >
                {beforeForm}
                {title}
                {subtitle}
                {children}
            </main>
        </div>
        {footer}
    </article>
);

export default LoginLayout;
